import { Component, OnInit } from "@angular/core";
import { AppService } from "../services/app.service";
import { DatePipe } from "@angular/common";

@Component({
  selector: "app-billing-log",
  templateUrl: "./billing-log.component.html",
})
export class BillingLogComponent implements OnInit {
  constructor(private appservice: AppService, private datePipe: DatePipe) {}
  pageNumber = 1;
  pageRecord = 10;
  search = "";
  searchText = "";
  countryData = [];
  stateData = [];
  countryidadmin: any = "";
  stateidadmin: any = "";
  country: any = "";
  selectedCountry: any = "";
  selectedState: any = "";
  billinglog = [];
  billinglogs = [];
  count = 0;
  ngOnInit() {
    const data = {
      pageNumber: this.pageNumber,
      pageRecord: this.pageRecord,
      type: "approved",
      search: this.search,
      countryid: this.countryidadmin,
      stateid: this.stateidadmin,
    };
    this.getBillingLog(data);
    this.getAllCountry();
  }

  convertutctolocal(value, type, offset) {
    let flag;
    if (value) {
      let zoneDate = new Date(value);
      if (type === "invoice") {
        zoneDate.setDate(zoneDate.getDate() - 1);
        flag = this.datePipe.transform(
          zoneDate.setMinutes(zoneDate.getMinutes() + +offset),
          "MMM dd, yyyy"
        );
      } else {
        flag = this.datePipe.transform(
          zoneDate.setMinutes(zoneDate.getMinutes() + +offset),
          "MMM dd, yyyy"
        );
      }
    }
    return flag;
  }

  getAllCountry() {
    this.appservice.getCountry().subscribe((res) => {
      if (res && res["status"] && res["status"]["status"] === 200) {
        this.countryData = res["entity"];
      } else {
        this.countryData = [];
      }
    });
  }

  getAllStateByCountry(countryid) {
    this.appservice.getState(countryid).subscribe((res) => {
      if (res && res["status"] && res["status"]["status"] === 200) {
        this.stateData = res["entity"];
      } else {
        this.stateData = [];
      }
    });
  }

  onChangeState(event) {
    sessionStorage.setItem("stateidadmin", this.selectedState.id);
    this.stateidadmin = sessionStorage.getItem("stateidadmin");
    this.searchbilling("");
  }

  onChange(event) {
    sessionStorage.setItem("countryidadmin", this.selectedCountry.id);
    this.countryidadmin = sessionStorage.getItem("countryidadmin");
    this.stateidadmin = "";
    this.getAllStateByCountry(event.id);
    this.selectedState = "";
    this.searchbilling("");
  }
  searchbilling(value) {
    this.search = value;
    const data = {
      pageNumber: 1,
      pageRecord: this.pageRecord,
      type: "approved",
      search: this.search,
      countryid: this.countryidadmin,
      stateid: this.stateidadmin,
    };
    this.getBillingLog(data);
  }

  pageChanged(event) {
    const data = {
      pageNumber: event.page,
      pageRecord: this.pageRecord,
      type: "approved",
      search: this.search,
      countryid: this.countryidadmin,
      stateid: this.stateidadmin,
    };
    this.getBillingLog(data);
  }
  getBillingLog(data) {
    this.appservice.getBillingApprovedReport(data).subscribe((res) => {
      if (res && res["entity"]) {
        this.billinglog = [];
        this.billinglogs = [];
        this.count = res["count"];
        for (let index = 0; index < res["entity"].length; index++) {
          const groupBy = this.convertutctolocal(
            res["entity"][index].createdOn,
            "",
            res["entity"][index].offSet
          );
          res["entity"][index].formatedCreatedOn = groupBy;
          this.billinglogs[index] = res["entity"][index];
          this.billinglogs[index].groupBy = groupBy;
        }
        this.billinglog = this.groupBy(this.billinglogs, "groupBy");
        for (let index = 0; index < this.billinglog.length; index++) {
          let totalAmount = 0;
          for (let j = 0; j < this.billinglog[index].value.length; j++) {
            totalAmount += this.getRound(
              +this.billinglog[index].value[j].paidAmount
            );
            if (this.billinglog[index].value.length === j + 1) {
              this.billinglog[index].value[j].totalAmount = +totalAmount;
            }
          }
        }
      }
    });
  }

  getRound(value): number {
    if (value) {
      return Math.round(value * 100) / 100;
    }
    return 0;
  }

  groupBy(collection: any, property: string): any {
    if (!collection) {
      return null;
    }
    const groupedCollection = collection.reduce((previous, current) => {
      if (!previous[current[property]]) {
        previous[current[property]] = [current];
      } else {
        previous[current[property]].push(current);
      }
      return previous;
    }, {});
    return Object.keys(groupedCollection).map((key) => ({
      key,
      value: groupedCollection[key],
    }));
  }

  refreshPatient() {
    this.searchText = "";
    this.selectedCountry = "";
    this.selectedState = "";
    const data = {
      pageNumber: this.pageNumber,
      pageRecord: this.pageRecord,
      type: "approved",
      search: "",
      countryid: "",
      stateid: "",
    };
    this.getBillingLog(data);
  }
}
